import Vue from 'vue'
import Router from 'vue-router'

if (!window.VueRouter) {
  Vue.use(Router)
} else {
  Vue.use(window.VueRouter)
}

// Vue.use(Router)

/* Layout */

/* 模块化 路由 */
// import tempRouter from '@/router/modules/temp'
// import temperatureRouter from '@/router/modules/temperature'
// import smartRouter from '@/router/modules/smartdevice'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
// 404 页面
const View404 = r =>
  require.ensure(
    [],
    () => r(require(/* webpackChunkName: "404" */ '@/views/404')),
    'View404'
  )
const Layout = r =>
  require.ensure(
    [],
    () => r(require(/* webpackChunkName: "layout" */ '@/layout')),
    'layout'
  )

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/screen',
    component: () => import('@/views/screen/index'),
    name: "大屏页",
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
      path: 'dashboard',
      name: 'Dashboard',
      component: ()=>import('@/views/home/index'),
        meta: {
        title:'首页',
          icon: 'dashboard',
          keepAlive: true,
        }
      }
    ],
  },
  {
    path: '/404',
    component: View404,
    hidden: true
  }
  //, tempRouter
]

/**
 * 创建路由
 */
const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

/**
 * 重置菜单权限
 */
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

/**
 * 需要审核权限菜单
 */
// export const asyncRoutes = []

export default router
